import React from 'react'
import { TextField } from '@material-ui/core'
import { useController } from 'react-hook-form'

export default function PasswordConfirmation({ control, password, ...passThroughProps }) {
  const { field, fieldState: { error, invalid } } = useController({
    name: 'passwordConfirmation',
    defaultValue: '',
    control,
    rules: {
      required: { value: true, message: 'Required' },
      validate: value => value === password || "doesn't match password"
    }
  })

  return (
    <TextField
      {...field}
      autoComplete='new-password'
      label='Re-enter Password'
      name='passwordConfirmation'
      type='password'
      required
      helperText={error?.message || '*Required'}
      error={invalid}
      { ...passThroughProps }
    />
  )
}
